import React from "react";

const PageNotFound = () => <div id="content"><div id="content-title">Oops! Page not found.</div></div>;

export default PageNotFound;
